export enum EApiPathParams {
  CounterpartyGuid = '<counterparty_guid>',
  BranchGuid = '<branch_guid>',
  AccountGuid = '<account_guid>',
  CustomerGuid = '<customer_guid>',
  EmployeeGuid = '<employee_guid>',
  AssetsHistoryRecordGuid = '<assets_history_record_guid>',
  ReconGuid = '<recon_guid>',
  MerchantGuid = '<merchant_guid>',
  PermissionGuid = '<permission_guid>',
}
